"use strict";
import { __module as t } from "./index.es457.js";
import { __require as s } from "./index.es458.js";
var a;
function _() {
  return a ? t.exports : (a = 1, (function(u, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "hasBasePath", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const r = s(), f = process.env.__NEXT_ROUTER_BASEPATH || "";
    function n(i) {
      return (0, r.pathHasPrefix)(i, f);
    }
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), u.exports = e.default);
  })(t, t.exports), t.exports);
}
export {
  _ as __require
};
//# sourceMappingURL=index.es385.js.map
